<template>
  <div
    id="topNav"
    :class="{ slideinNav: showNav }"
    v-if="global.screenWidth < 700"
  >
    <MobileNav />
  </div>
  <div id="topNav" :class="{ slideinNav: showNav }" v-else>
    <PrimaryNav />
  </div>
</template>

<script>
import PrimaryNav from "@/components/TopNav/PrimaryNav";
import MobileNav from "@/components/TopNav/MobileNav";
import { mapState } from "vuex";
export default {
  name: "TopNav",
  components: {
    PrimaryNav,
    MobileNav,
  },
  computed: {
    ...mapState(["global"]),
  },
  data() {
    return {
      showNav: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const isMobile = window.innerWidth < 700;
      const showAt = window.innerHeight * 1.6 - (!isMobile ? 80 : 50);
      this.showNav = window.scrollY >= showAt;
    });
  },
};
</script>

<style lang="scss" scoped>
#topNav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 999;
  opacity: 0;
  transform: translateY(-100%);
  transition: all 0.25s ease-in;
}
.slideinNav {
  opacity: 1 !important;
  transform: translateY(0) !important;
}
</style>